// extracted by mini-css-extract-plugin
export default {"userActive":"styles_userActive__6AGaY"};